import { CANONICAL_ORIGIN, absoluteUrl, touristAttraction } from './shared'

export interface PlacePageInput {
  kind?: string | null
  name?: string | null
  byline?: string | null
  url?: string | null
  heroImage?: { large?: string | null; hero?: string | null } | null
  region?: { name?: string | null } | null
  place?: { origin?: number[] | null } | null
}

const withoutBlanks = (data: Record<string, unknown>) =>
  Object.fromEntries(
    Object.entries(data).filter(([, value]) => value !== undefined),
  )

// A town is a schema.org Place; a point of interest is a TouristAttraction.
export const placePageJsonLd = (
  page: PlacePageInput | null | undefined,
  { origin = CANONICAL_ORIGIN }: { origin?: string } = {},
) => {
  const url = absoluteUrl(page?.url, origin)
  if (!page || !url) return null

  const [lat, lng] = page.place?.origin ?? []
  const location = lat != null && lng != null ? { lat, lng } : null
  const attraction = touristAttraction(
    {
      url,
      name: page.name,
      image: page.heroImage?.large || page.heroImage?.hero,
      description: page.byline,
      location,
    },
    origin,
  )

  return withoutBlanks({
    '@context': 'https://schema.org',
    ...attraction,
    '@type': page.kind === 'point_of_interest' ? 'TouristAttraction' : 'Place',
    containedInPlace: page.region?.name
      ? { '@type': 'AdministrativeArea', name: page.region.name }
      : undefined,
  })
}
